import "core-js/modules/es6.reflect.construct.js";
import _createClass from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import "core-js/modules/es6.function.name.js";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import http from 'http';
var APIError = /*#__PURE__*/function (_Error) {
  _inherits(APIError, _Error);
  var _super = _createSuper(APIError);
  function APIError(statusCode, message, errors) {
    var _this;
    _classCallCheck(this, APIError);
    var name = http.STATUS_CODES[statusCode];
    _this = _super.call(this, "".concat(statusCode, " ").concat(name));
    _this.name = name;
    _this.statusCode = statusCode;
    _this.userMessage = message;
    _this.errors = errors;
    return _this;
  }
  return _createClass(APIError);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export default APIError;